import React, { useState, useEffect } from "react";
import moment from "moment";
import _ from "lodash";
import CardButton from "./Button";
import CollapseText from "./CollapseText";
import cardImage from "assets/images/challenges/card-home.jpg";

const CardHome = ({
  challenge: {
    name,
    end_date,
    description,
    challenge_id,
    participants,
    challenge_image
  },
  main_params,
  history
}) => {
  const days_left = _.get(main_params, "days_left", "Days Left");
  const view_challenge = _.get(main_params, "view_challenge", "View Challenge");
  const participated = _.get(
    main_params,
    "participated",
    "Teammates have participated"
  );

  const [participantsLength, setParticipantsLength] = useState(0);

  useEffect(() => {
    let count = 0;
    participants.forEach((item) => {
      item.data !== 0 && count++;
    });
    setParticipantsLength(count);
  }, [participants]);

  const handleViewChallenge = () => {
    history.push({
      pathname: `/challenge/${challenge_id}`
    });
  };

  const daysLeft = () => {
    if (moment(end_date, "MM/DD/YYYY").isSame(moment().format("MM/DD/YYYY"))) {
      return 0;
    } else {
      let eventdate = moment(end_date, "MM/DD/YYYY").add(1, "days");
      let todaysdate = moment();
      return eventdate.diff(todaysdate, "days");
    }
  };

  return (
    <div className="home-card">
      <img
        alt=""
        src={challenge_image !== null ? challenge_image : cardImage}
        className="card-top-image"
      />
      <div className="card-content">
        <span className="challenge-time-left">{`${daysLeft()} ${
          daysLeft() === 1 ? "Day Left" : days_left
        }`}</span>
        <h2 className="challenge-name">{name}</h2>
        <CollapseText
          params={main_params}
          description={description}
          challenge_id={challenge_id}
        />
        <CardButton text={view_challenge} onPress={handleViewChallenge} />
        <span className="challenge-members">
          {participantsLength} {participated}
        </span>
      </div>
    </div>
  );
};

export default CardHome;
